import React from "react";
import PropTypes from "prop-types";

/**
 * Centered card shell shared by the login and signup pages.
 *
 * `className` carries the page's own hook (`login-content` / `signup-content`,
 * both asserted by the e2e suite) plus its max-width — pass the width here
 * rather than relying on class order, since Tailwind resolves conflicts by CSS
 * source order, not the order classes appear in the attribute.
 */
const AuthShell = ({ className = "", children }) => (
  <div className="relative flex min-h-[calc(100vh-5rem)] items-center justify-center overflow-hidden bg-ink-50 px-4 pb-16 pt-28">
    {/* Brand wash, matching the About section's treatment. */}
    <div
      aria-hidden="true"
      className="pointer-events-none absolute inset-x-0 top-0 h-72 bg-gradient-to-b from-brand-50 to-transparent"
    />

    <div
      className={`relative rounded-card border border-ink-200 bg-white p-6 shadow-card sm:p-8 ${className}`}
    >
      {children}
    </div>
  </div>
);

AuthShell.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

export default AuthShell;
